import React, { Component } from 'react';
import JackpotKiosk from "../pages/JackpotKiosk";
import MSLogin from "../pages/MSLogin";
import Login from "../pages/Login";

class PublicRoute extends Component {
    render() {
        const { location, cookies, history, settings, userAuthenticated } = this.props;
        if (location.pathname === "/blocked") {
            var x = document.getElementById("loader-wrapper");
            x.style.display = "none";
            return (
                <div style={{ textAlign: 'center', marginTop: '300px' }}>
                    <title>Site Unavailable</title>
                    <h1>Site Unavailable</h1>
                    <p>This site is currently unavailable. If you're uncertain why you received this message, please don't hesitate to contact our support team at 1-800-815-0867 (Option 1)</p>
                </div>
            );
        } else {
            return (
                <>
                    {location.pathname === "/jackpot"
                        ? <JackpotKiosk location={location} defaultJackpotId={settings ? settings.general.default_jackpot_id : 0} />
                        : location.pathname === "/letsgo"
                        ? <MSLogin cookies={cookies} history={history} />
                        : !userAuthenticated && <Login cookies={cookies} history={history} userAuthenticated={userAuthenticated} />
                    }
                </>
            );
        }
    }
}

export default PublicRoute;
